/*
 * MDB shim for MDBSpinner
 * Files currently importing this symbol from "mdbreact":
 * - src/Components/Pipeline/MonthGlance.jsx
 * - src/Seating/Patient/PatientViewComponents/attachmentsTab.jsx
 * - src/Seating/Patient/PatientViewComponents/patientInformationTab.jsx
 * - src/Seating/Patient/patientInformationView.jsx
 * - src/Seating/Patient/patientOrderView.jsx
 * - src/Seating/PurchaseQueue/ServicePartList.jsx
 * - src/Seating/PurchaseQueue/purchaseQueueTable.jsx
 */

import MUICircularProgress from "@mui/material/CircularProgress";

export default function MDBSpinner(props) {
    return <MUICircularProgress {...props} />;
}
